import { render, staticRenderFns } from "./scan-reader.vue?vue&type=template&id=47232af0&scoped=true&"
import script from "./scan-reader.vue?vue&type=script&lang=js&"
export * from "./scan-reader.vue?vue&type=script&lang=js&"
import style0 from "./scan-reader.vue?vue&type=style&index=0&id=47232af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47232af0",
  null
  
)

export default component.exports